import React, { useContext, useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { CloseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { AuthenticationService, ConfigurationService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { EngineContext } from '@philips-internal/oswald-ui-engine';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { ModalService } from '../../services/modal-service/modal-service.js';
import { Modal } from '../modal/modal.js';
function ModalManager(props) {
    const applicationContext = useContext(ApplicationContext.Context);
    const modals = useRef(new Map());
    const createModal = (id, modal, container) => {
        const { children, ...otherProps } = modal;
        return (React.createElement(ApplicationContext.Context.Provider, { value: applicationContext },
            React.createElement(BrowserRouter, { basename: ConfigurationService.getBaseURL() },
                React.createElement(EngineContext.Provider, { value: { engine: props.engine } },
                    React.createElement(Modal, { ...otherProps, container: container, onClose: () => onModalClose(id, false) }, children)))));
    };
    const onModalClose = (id, skipEvent) => {
        const item = modals.current.get(id);
        if (!item) {
            return;
        }
        const { container, modal, root } = item;
        if (!skipEvent && isFunction(modal.onClose)) {
            modal.onClose(new CloseEvent());
        }
        root.unmount();
        container.remove();
        modals.current.delete(id);
    };
    const closeAllModals = () => {
        for (const [id] of modals.current) {
            onModalClose(id, true);
        }
    };
    const openModal = (modal) => {
        const id = modal.id ?? generateUUID();
        const container = document.createElement('div');
        document.body.append(container);
        const modalElement = createModal(id, modal, container);
        const root = createRoot(container);
        modals.current.set(id, {
            container,
            modal,
            root,
        });
        root.render(modalElement);
    };
    useEffect(() => {
        const listeners = [
            AuthenticationService.listenLogout(() => closeAllModals()),
            ModalService.addCloseListener((id) => onModalClose(id, false)),
            ModalService.addListener((modal) => openModal(modal)),
        ];
        return () => {
            listeners.forEach((callback) => callback());
            closeAllModals();
        };
    }, []);
    return null;
}
export default ModalManager;
//# sourceMappingURL=modal-manager.js.map